export default __webpack_public_path__ + "static/media/558.cf063c65.gif";